<!-- Modal Header -->
<div class="modal-header border-0 pb-2">
  <div class="d-flex align-items-center flex-grow-1">
    <div class="create-course-icon me-3">
      <i class="bi bi-book-fill"></i>
    </div>
    <div>
      <h4 class="modal-title mb-1">สร้างคอร์สอบรม/สัมมนาใหม่</h4>
      <p class="text-muted mb-0 small">เพิ่มคอร์สอบรม/สัมมนาเข้าสู่ระบบ VAT</p>
    </div>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
</div>

<!-- Progress Bar -->
<div class="modal-progress">
  <div class="progress">
    <div class="progress-bar bg-success" role="progressbar" [style.width.%]="getProgressPercentage()"
      [attr.aria-valuenow]="getProgressPercentage()" aria-valuemin="0" aria-valuemax="100">
    </div>
  </div>
  <div class="progress-steps">
    <div class="step-container">
      <div *ngFor="let step of [1, 2]" class="step-item">
        <div class="step-circle" [class.completed]="isStepCompleted(step)" [class.current]="isStepCurrent(step)"
          [class.clickable]="step <= currentStep" (click)="goToStep(step)">
          <i *ngIf="isStepCompleted(step)" class="bi bi-check-lg"></i>
          <i *ngIf="isStepCurrent(step)" class="{{ getStepIcon(step) }}"></i>
          <span *ngIf="!isStepCompleted(step) && !isStepCurrent(step)">{{ step }}</span>
        </div>
        <div class="step-label">{{ getStepTitle(step) }}</div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body">
  <form [formGroup]="createCourseForm" (ngSubmit)="onSubmit()">

    <!-- Step 1: Course Information -->
    <div class="step-content" *ngIf="currentStep === 1">
      <div class="step-header">
        <h5 class="step-title">
          <i class="bi bi-book me-2"></i>ข้อมูลคอร์สอบรม/สัมมนา
        </h5>
        <p class="step-description">กรอกข้อมูลรายละเอียดคอร์สอบรม/สัมมนา</p>
      </div>

      <div class="row">
        <!-- Course Topic -->
        <div class="col-md-12 mb-3">
          <label class="form-label required">หัวข้ออบรม/สัมมนา</label>
          <input type="text" class="form-control" formControlName="courseTopic"
            [class.is-invalid]="hasError('courseTopic')" placeholder="กรอกหัวข้ออบรม/สัมมนา">
          <div class="invalid-feedback" *ngIf="hasError('courseTopic')">
            {{ getErrorMessage('courseTopic') }}
          </div>
        </div>

        <!-- Certification by SEC -->
        <div class="col-md-6 mb-3">
          <label class="form-label">การรับรอง โดย กลต.</label>
          <select class="form-select" formControlName="certificationBySEC">
            <option [ngValue]="false">ไม่มีการรับรอง</option>
            <option [ngValue]="true">รับรอง</option>
          </select>
        </div>

        <!-- CPD Hours -->
        <div class="col-md-6 mb-3">
          <label class="form-label required">จำนวน CPD (ชั่วโมง)</label>
          <input type="number" class="form-control" formControlName="cpdHours" [class.is-invalid]="hasError('cpdHours')"
            placeholder="0" min="0" max="500" step="0.5">
          <div class="invalid-feedback" *ngIf="hasError('cpdHours')">
            {{ getErrorMessage('cpdHours') }}
          </div>
        </div>

        <!-- Training Format -->
        <div class="col-md-6 mb-3">
          <label class="form-label required">รูปแบบการอบรม/สัมมนา</label>
          <select class="form-select" formControlName="trainingFormat" [class.is-invalid]="hasError('trainingFormat')">
            <option value="">เลือกรูปแบบการอบรม</option>
            <option value="onsite">อบรมในสถานที่</option>
            <option value="online">อบรมออนไลน์</option>
            <option value="hybrid">อบรมแบบผสม (Onsite + Online)</option>
          </select>
          <div class="invalid-feedback" *ngIf="hasError('trainingFormat')">
            {{ getErrorMessage('trainingFormat') }}
          </div>
        </div>

        <!-- Training Location -->
        <div class="col-md-6 mb-3">
          <label class="form-label">สถานที่อบรม</label>
          <input type="text" class="form-control" formControlName="trainingLocation"
            placeholder="กรอกสถานที่อบรม (ถ้ามี)">
        </div>

        <!-- Start Date -->
        <div class="col-md-6 mb-3">
          <label class="form-label required">วันที่เริ่มอบรม</label>
          <input type="datetime-local" class="form-control" formControlName="startDate"
            [class.is-invalid]="hasError('startDate')">
          <div class="invalid-feedback" *ngIf="hasError('startDate')">
            {{ getErrorMessage('startDate') }}
          </div>
        </div>

        <!-- End Date -->
        <div class="col-md-6 mb-3">
          <label class="form-label required">วันที่อบรมวันสุดท้าย</label>
          <input type="datetime-local" class="form-control" formControlName="endDate" [class.is-invalid]="hasError('endDate')">
          <div class="invalid-feedback" *ngIf="hasError('endDate')">
            {{ getErrorMessage('endDate') }}
          </div>
        </div>

        <!-- Registration Close Date -->
        <div class="col-md-6 mb-3">
          <label class="form-label">วันปิดรับสมัคร</label>
          <input type="datetime-local" class="form-control" formControlName="closeRegisterDate">
        </div>

        <!-- Course Fee -->
        <div class="col-md-6 mb-3">
          <label class="form-label">ค่าที่อบรม/สัมมนา (รวม VAT แล้ว)</label>
          <div class="input-group">
            <input type="number" class="form-control" formControlName="courseFee" placeholder="0" min="0" step="0.01">
            <span class="input-group-text">บาท</span>
          </div>
        </div>

        <!-- Max Participants -->
        <div class="col-md-6 mb-3">
          <label class="form-label required">จำนวนผู้เข้าอบรม/สัมมนา ที่เปิดรับ</label>
          <input type="number" class="form-control" formControlName="maxParticipants"
            [class.is-invalid]="hasError('maxParticipants')" placeholder="0" min="1">
          <div class="invalid-feedback" *ngIf="hasError('maxParticipants')">
            {{ getErrorMessage('maxParticipants') }}
          </div>
        </div>

        <!-- Course Status -->
        <div class="col-md-6 mb-3">
          <label class="form-label required">สถานะคอร์สอบรม/สัมมนา</label>
          <select class="form-select" formControlName="courseStatus" [class.is-invalid]="hasError('courseStatus')">
            <option [ngValue]="null">เลือกสถานะ</option>
            <option *ngFor="let status of courseStatusList" [ngValue]="status.id">
              {{ status.name }}
            </option>
          </select>
          <div class="invalid-feedback" *ngIf="hasError('courseStatus')">
            {{ getErrorMessage('courseStatus') }}
          </div>
        </div>

        <!-- Remarks -->
        <div class="col-12 mb-3">
          <label class="form-label">หมายเหตุ</label>
          <textarea class="form-control" formControlName="remarks" rows="3"
            placeholder="กรอกหมายเหตุเพิ่มเติม (ถ้ามี)"></textarea>
        </div>        

        <!-- Image Detail Upload -->
        <div class="col-md-6 mb-3">
          <label class="form-label">รูปภาพรายละเอียด</label>
          <div class="file-upload-container">
            <input type="file" class="form-control" id="imageDetailInput" accept="image/jpeg,image/jpg,image/png,image/gif"
              (change)="onImageDetailSelected($event)">
            <small class="form-text text-muted">รองรับไฟล์: JPG, PNG, GIF (ขนาดไม่เกิน 5MB)</small>
            
            <!-- Preview -->
            <div class="image-preview mt-2" *ngIf="imageDetailPreview">
              <img [src]="imageDetailPreview" alt="รูปภาพรายละเอียด" class="img-thumbnail">
              <button type="button" class="btn btn-sm btn-danger mt-2" (click)="removeImageDetail()">
                <i class="bi bi-trash"></i> ลบรูปภาพ
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Step 2: Review and Confirm -->
    <div class="step-content" *ngIf="currentStep === 2">
      <div class="step-header">
        <h5 class="step-title">
          <i class="bi bi-check-circle me-2"></i>ตรวจสอบและยืนยัน
        </h5>
        <p class="step-description">ตรวจสอบข้อมูลก่อนบันทึก</p>
      </div>

      <div class="review-container">
        <!-- Course Information Review -->
        <div class="review-section">
          <h6 class="review-section-title">
            <i class="bi bi-book me-2"></i>ข้อมูลคอร์สอบรม/สัมมนา
          </h6>
          <div class="review-grid">
            <div class="review-item">
              <span class="review-label">หัวข้ออบรม/สัมมนา:</span>
              <span class="review-value">{{ createCourseForm.get('courseTopic')?.value || '-' }}</span>
            </div>
            <div class="review-item">
              <span class="review-label">การรับรอง โดย กลต.:</span>
              <span class="review-value">{{ createCourseForm.get('certificationBySEC')?.value ? 'รับรอง' : 'ไม่มีการรับรอง' }}</span>
            </div>
            <div class="review-item">
              <span class="review-label">จำนวน CPD:</span>
              <span class="review-value">
                <span class="badge bg-primary">{{ createCourseForm.get('cpdHours')?.value || 0 }} ชั่วโมง</span>
              </span>
            </div>
            <div class="review-item">
              <span class="review-label">รูปแบบการอบรม:</span>
              <span class="review-value">{{ getTrainingFormatLabel(createCourseForm.get('trainingFormat')?.value)
                }}</span>
            </div>
            <div class="review-item">
              <span class="review-label">สถานที่อบรม:</span>
              <span class="review-value">{{ createCourseForm.get('trainingLocation')?.value || '-' }}</span>
            </div>
            <div class="review-item">
              <span class="review-label">วันที่เริ่มอบรม:</span>
              <span class="review-value">{{ formatDate(createCourseForm.get('startDate')?.value) }}</span>
            </div>
            <div class="review-item">
              <span class="review-label">วันที่อบรมวันสุดท้าย:</span>
              <span class="review-value">{{ formatDate(createCourseForm.get('endDate')?.value) }}</span>
            </div>
            <div class="review-item" *ngIf="createCourseForm.get('closeRegisterDate')?.value">
              <span class="review-label">วันปิดรับสมัคร:</span>
              <span class="review-value">{{ formatDate(createCourseForm.get('closeRegisterDate')?.value) }}</span>
            </div>
            <div class="review-item">
              <span class="review-label">ค่าอบรม/สัมมนา:</span>
              <span class="review-value">{{ createCourseForm.get('courseFee')?.value || 0 | number:'1.2-2' }} บาท</span>
            </div>
            <div class="review-item">
              <span class="review-label">จำนวนที่เปิดรับ:</span>
              <span class="review-value">
                <span class="badge bg-info">{{ createCourseForm.get('maxParticipants')?.value || 0 }} คน</span>
              </span>
            </div>
            <div class="review-item">
              <span class="review-label">สถานะคอร์ส:</span>
              <span class="review-value">
                <span class="badge" [ngClass]="getCourseStatusBadgeClass(createCourseForm.get('courseStatus')?.value)">
                  {{ getCourseStatusLabel(createCourseForm.get('courseStatus')?.value) }}
                </span>
              </span>
            </div>
            <div class="review-item" *ngIf="createCourseForm.get('remarks')?.value">
              <span class="review-label">หมายเหตุ:</span>
              <span class="review-value">{{ createCourseForm.get('remarks')?.value }}</span>
            </div>
          </div>
        </div>

        <!-- Image Uploads Review -->
        <div class="review-section" *ngIf="imageThumbnailPreview || imageDetailPreview">
          <h6 class="review-section-title">
            <i class="bi bi-image me-2"></i>รูปภาพที่อัปโหลด
          </h6>
          <div class="review-grid">
            <div class="review-item" *ngIf="imageThumbnailPreview">
              <span class="review-label">รูปภาพปก:</span>
              <span class="review-value">
                <img [src]="imageThumbnailPreview" alt="รูปภาพปก" class="img-thumbnail" style="max-width: 200px;">
              </span>
            </div>
            <div class="review-item" *ngIf="imageDetailPreview">
              <span class="review-label">รูปภาพรายละเอียด:</span>
              <span class="review-value">
                <img [src]="imageDetailPreview" alt="รูปภาพรายละเอียด" class="img-thumbnail" style="max-width: 200px;">
              </span>
            </div>
          </div>
        </div>

      </div>
    </div>

  </form>
</div>

<!-- Modal Footer -->
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="dismiss()" [disabled]="isSubmitting">
    <i class="bi bi-x-circle me-2"></i>ยกเลิก
  </button>

  <button type="button" class="btn btn-secondary" *ngIf="currentStep > 1" (click)="prevStep()"
    [disabled]="isSubmitting">
    <i class="bi bi-arrow-left me-2"></i>ย้อนกลับ
  </button>

  <button type="button" class="btn btn-success" *ngIf="currentStep < totalSteps" (click)="nextStep()"
    [disabled]="isSubmitting">
    ถัดไป<i class="bi bi-arrow-right ms-2"></i>
  </button>

  <button type="button" class="btn btn-success" *ngIf="currentStep === totalSteps" (click)="onSubmit()"
    [disabled]="isSubmitting">
    <span *ngIf="!isSubmitting">
      <i class="bi bi-check-circle me-2"></i>บันทึกข้อมูล
    </span>
    <span *ngIf="isSubmitting">
      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      กำลังบันทึก...
    </span>
  </button>
</div>